<template>
    <div class="flex">

        <div class="col-7">
            <!-- Modal -->
            <div id="templateNameModal" class="modal fade" role="dialog">
                <div class="modal-dialog modal-md">
                    <!-- Modal content-->
                    <div class="modal-content">
                        <div class="modal-header">
                            <h4 class="modal-title text-lg">
                                Template Name
                            </h4>
                            <button type="button" dusk="modal-close-button"
                                    class="material-icons focus:outline-none text-grey-darkest hover:text-grey-darkest"
                                    data-dismiss="modal">close
                            </button>
                        </div>
                        <div class="modal-body">
                            <form @keydown="templateForm.errors.clear($event.target.name)">
                                <div class="mb-2">
                                    <div class="form-group">
                                        <input v-model="templateForm.template_name" class="form-control"
                                               :class="{'border-red': templateForm.errors.has('template_name')}" type="text"
                                               id="template_name">
                                    </div>
                                    <div class="text-red text-xs" v-if="templateForm.errors.has('template_name')">
                                        {{ templateForm.errors.get('template_name') }}
                                    </div>
                                </div>
                            </form>
                        </div>
                        <div class="modal-footer">
                            <button id="save-as-template" name="save-as-template"
                                    @click.prevent="saveAsTemplate"
                                    class="bg-followup-nav hover:bg-followup-nav-darker px-3 py-1 rounded-full text-white focus:outline-none">
                                Save
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="flex items-start my-3">
                <!--                <button @click="saveQuoteDetails" class="btn btn-outline-primary rounded-full">-->
                <!--                    Save-->
                <!--                </button>-->

                <button @click.prevent="addPage" class="btn btn-outline-secondary rounded-full flex ml-2">
                    <span class="material-icons">add</span>
                    Add Page
                </button>
            </div>

            <div v-for="(page, idx) in tempSection.sections.data" :key="idx" class="card bg-white shadow">
                <div class="flex mt-4 col justify-start">
                    <div class="form-group w-full">
                        <label class="mr-2 font-bold tracking-wide">Page Title</label>
                        <div class="flex justify-between">
                            <input @input="updatePage(page.id, idx)" v-model="page.title" type="text" class="form-control">
                            <span @click="deletePage(page.id)" class="material-icons text-red col-1 cursor-pointer">delete</span>
                        </div>
                    </div>
                </div>

                <div v-for="(section, sectionIndex) in page.subSections" :key="section.uniqueIdentifier"
                     class="bg-white p-2">
                    <div class="card-body">
                        <div class="flex justify-between items-center mb-4">
                            <div class="form-group col-11">
                                <div class="flex items-end">
                                    <label class="mr-2 font-bold tracking-wide" :for="section.uniqueIdentifier">Section
                                        Title</label>
                                    <span class="material-icons cursor-pointer text-4xl" @click="moveDown(sectionIndex)">arrow_drop_down</span>
                                    <span class="material-icons cursor-pointer text-4xl" @click="moveUp(sectionIndex)">arrow_drop_up</span>
                                </div>
                                <input @input="updateSection(section.id, idx, sectionIndex)" v-model="section.title" type="text" class="form-control" :id="section.uniqueIdentifier">
                            </div>
                            <span @click="deleteSection(section.id, idx)" class="material-icons text-red col-1 cursor-pointer">delete</span>
                        </div>
                        <div class="flex font-bold mb-4 tracking-wide">
                            <div class="col-1"></div>
                            <div class="col-4">Item</div>

                            <div v-show="!customColumns[page.id + '-' + section.id + '-' + 1]" @click="enableEditColumn(page.id + '-' + section.id + '-' + 1)" class="col-2" v-model="customColumns">{{ section.custom_column_1 }}</div>
                            <input v-show="customColumns[page.id + '-' + section.id + '-' + 1]" :id="page.id + '-' + section.id + '-' + 1" v-model="section.custom_column_1" @blur="customColumns[page.id + '-' + section.id + '-' + 1] = false" @change="updateSectionCustomColumn(section.id, idx, sectionIndex)" class="col-2 form-control">

                            <div v-show="!customColumns[page.id + '-' + section.id + '-' + 2]" @click="enableEditColumn(page.id + '-' + section.id + '-' + 2)" class="col-2" v-model="customColumns">{{ section.custom_column_2 }}</div>
                            <input v-show="customColumns[page.id + '-' + section.id + '-' + 2]" :id="page.id + '-' + section.id + '-' + 2" v-model="section.custom_column_2" @blur="customColumns[page.id + '-' + section.id + '-' + 2] = false" @change="updateSectionCustomColumn(section.id, idx, sectionIndex)" class="col-2 form-control">

                            <div class="col-2">Line Total</div>
                            <div class="col-1"></div>
                        </div>
                        <draggable v-model="section.items" @change="handleSubitemOrderChange($event, sectionIndex)">
                            <transition-group>
                                <div v-for="(item, itemIndex) in section.items"
                                     :key="item.id"
                                     class="cursor-pointer flex mb-4">
                                    <div class="col-1">
                                        <span class="material-icons">drag_indicator</span>
                                    </div>
                                    <div class="col-4">
                                            <textarea @input="updateItem(item.id, idx, sectionIndex, itemIndex)" v-model="item.title"
                                                      class="form-control non-resizeable"></textarea>
                                    </div>
                                    <div class="col-2">
                                        <input @input="updateItem(item.id, idx, sectionIndex, itemIndex)" v-model="item.quantity" type="number" class="form-control">
                                    </div>
                                    <div class="col-2">
                                        <input @input="updateItem(item.id, idx, sectionIndex, itemIndex)" v-model="item.price" type="number" class="form-control">
                                    </div>
                                    <div class="col-2">
                                        <div>${{ computeTotal(item) }}</div>
                                    </div>
                                    <div class="col-1">
                                            <span @click="deleteItem(item.id, idx, sectionIndex)"
                                                  class="material-icons text-red cursor-pointer">delete</span>
                                    </div>
                                </div>
                            </transition-group>
                        </draggable>
                        <div class="flex mt-4 col">
                            <button @click="addItem(section.id, idx, sectionIndex)" class="btn btn-outline-secondary rounded-full flex">
                                <span class="material-icons">add</span>
                                Add Item
                            </button>
                        </div>
                    </div>
                </div>
                <div class="bg-white p-2">
                    <div class="card-body">
                        <div class="col">
                            <button @click="addSection(page.id, idx)" class="btn btn-outline-secondary rounded-full flex">
                                <span class="material-icons">add</span>
                                Add Section
                            </button>
                        </div>
                        <hr>

                        <b-row>
                            <b-col cols="8" class="text-right">
                                <label for="switch-total">
                                    Hide / Show
                                </label>
                            </b-col>
                            <b-col>
                                <b-form-checkbox switch size="lg" :id="`switch-total${idx}`" v-model="page.show_total" @change="updatePage(page.id, idx)"/>
                            </b-col>
                        </b-row>

                        <div class="col-6 offset-6">
                            <div class="flex justify-between">
                                <div class="text-xl">Quote subtotal</div>
                                <div class="text-xl">${{ calculateTotal(page) }}</div>
                            </div>
                            <hr>
                            <div class="flex justify-between">
                                <div class="font-bold text-xl">Total</div>
                                <div class="font-bold text-xl">${{ calculateTotal(page) }}</div>
                            </div>
                        </div>
                        <hr>
                        <div class="form-group">
                            <label for="notes" class="font-bold tracking-wide">Notes</label>
                            <ckeditor-proposal @input="updatePage(page.id, idx)" v-model="page.notes" name="notes" :id="`notes${idx}`"></ckeditor-proposal>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-5 preview">
            <div class="text-2xl bg-primary border-b-2 border-followup-nav px-3 py-2 text-white mb-3">
                Preview
            </div>

            <div class="card bg-white w-full mr-4 shadow">
                <iframe
                    :src="`/proposal/${tempSection.proposal_id}/proposal-generator/quote-details/${tempSection.id}`"
                    id="pdfPreview"
                    class="reports-frame-style"
                />
            </div>
        </div>

    </div>
</template>

<script>
    import Form           from "../../utils/form";
    import draggable      from 'vuedraggable';
    import Multiselect    from 'vue-multiselect';
    import axios          from 'axios';
    import Swal           from "sweetalert2";

    export default {
        props: ['section'],
        components: {draggable, Multiselect},
        data() {
            return {
                customColumns: {},
                tempSection: {
                    uniqueIdentifier: this.section.uniqueIdentifier,
                    id: this.section.id,
                    proposal_id: this.section.proposal_id,
                    name: this.section.name,
                    include_in_report: this.section.include_in_report,
                    order: this.section.order,
                    tag: this.section.tag,
                    deleteable: this.section.deleteable,
                    notes: this.section.notes,
                    signature_section: this.section.signature_section,
                    sections: [],
                },
                editName: false,
                templateForm: new Form({
                    template_name: this.section.template_name,
                    is_template: this.section.is_template,
                }),
                selectedTemplate: null,
                allTemplates: this.section.all_templates,
                isUpdateQuota:null,
                isUpdatePage: [],
                isUpdateSubSection: [],
                isUpdateItem: [],
                signature: this.section.signature_section,
            }
        },
        mounted() {
            this.loadPages();

            Bus.$emit('showButton', { button: 'template', value: this.templateForm.is_template });

            Bus.$on('openSaveAsTemplateModal', data => {
                this.openSaveAsTemplateModal();
            });

            Bus.$on('removeAsTemplate', data => {
                this.removeAsTemplate();
            });

            Bus.$on('signature', data => {
                this.tempSection.signature_section = data;
                this.signature = this.tempSection.signature_section;
            });

            Bus.$emit('signature', this.section.signature_section);

            Bus.$emit('allTemplates', this.allTemplates);

            Bus.$on('applyTemplate', data => {
                this.selectedTemplate = data;
                this.applyTemplate();
            });
        },
        methods: {
            handleSubitemOrderChange(event, sectionIndex) {
                if (event.moved) {
                    let oldIndex = event.moved.oldIndex;
                    let newIndex = event.moved.newIndex;
                    this.tempSection.sections[sectionIndex].items[newIndex].order = newIndex;
                    if (newIndex < oldIndex) {
                        for (let i = newIndex + 1; i <= oldIndex; i++) {
                            this.tempSection.sections[sectionIndex].items[i].order++;
                        }
                    } else {
                        for (let i = oldIndex; i < newIndex; i++) {
                            this.tempSection.sections[sectionIndex].items[i].order--;
                        }
                    }
                }
            },
            computeTotal(item) {
                return item.quantity * item.price;
            },
            addItem(subSectionId, idx, sectionIndex) {
                let self = this;
                axios.post(route('proposal-generator-subitems.store', {subSectionId}))
                    .then(function ({data}) {
                        self.tempSection.sections.data[idx].subSections[sectionIndex].items.push(data.data);
                        self.fireSuccessToast('Quote Details Successfully Updated!');
                    })
            },
            deleteItem(itemId, idx, sectionIndex) {
                let self = this;
                axios.delete(route('proposal-generator-subitems.destroy', {itemId}))
                    .then(function () {
                        self.tempSection.sections.data[idx].subSections[sectionIndex].items
                            = self.tempSection.sections.data[idx].subSections[sectionIndex].items.filter(function (item) {
                            return item.id != itemId;
                        })
                        self.fireSuccessToast('Quote Details Successfully Updated!');
                    })
            },
            updateItem(itemId, idx, sectionIndex, itemIndex) {
                let self = this;
                clearTimeout(self.isUpdateItem[itemId])
                self.isUpdateItem[itemId] = setTimeout(function () {
                    let item = self.tempSection.sections.data[idx].subSections[sectionIndex].items[itemIndex]
                    axios.put(route('proposal-generator-subitems.update', {itemId}), {title:item.title, quantity:item.quantity, price:item.price})
                        .then(function () {
                            self.fireSuccessToast('Quote Details Successfully Updated!');
                        })
                }, 3000)
            },
            addSection(pageId, pageIdx) {
                let self = this;
                axios.post(route('proposal-generator-subsection.store', {pageId}))
                    .then(function ({data}) {
                        self.tempSection.sections.data[pageIdx].subSections.push(data);
                        self.fireSuccessToast('Quote Details Successfully Updated!');

                        self.customColumns[pageId + '-' + data.id + '-' + 1] = false;
                        self.customColumns[pageId + '-' + data.id + '-' + 2] = false;
                    })
            },
            deleteSection(sectionId, idx) {
                let self = this;
                axios.delete(route('proposal-generator-subsection.destroy', {sectionId}))
                    .then(function () {
                        self.tempSection.sections.data[idx].subSections = self.tempSection.sections.data[idx].subSections.filter(function (item) {
                            return item.id != sectionId;
                        })
                        self.fireSuccessToast('Quote Details Successfully Updated!');
                    })
            },
            updateSection(sectionId, idx, sectionIndex) {
                let self = this;
                clearTimeout(self.isUpdateSubSection[sectionId])
                self.isUpdateSubSection[sectionId] = setTimeout(function () {
                    let subSection = self.tempSection.sections.data[idx].subSections[sectionIndex]
                    axios.put(route('proposal-generator-subsection.update', {sectionId}),
                        {title:subSection.title, custom_column_1:subSection.custom_column_1, custom_column_2:subSection.custom_column_2})
                        .then(function () {
                            self.fireSuccessToast('Quote Details Successfully Updated!');
                        })
                }, 3000)
            },
            moveDown(sectionIndex) {
                if (sectionIndex !== this.tempSection.sections.length - 1) {
                    let temp1 = this.tempSection.sections[sectionIndex];
                    temp1.order++;
                    let temp2 = this.tempSection.sections[sectionIndex + 1];
                    temp2.order--;
                    this.tempSection.sections.splice(sectionIndex, 2, temp2, temp1);
                }
            },
            moveUp(sectionIndex) {
                if (sectionIndex !== 0) {
                    let temp1 = this.tempSection.sections[sectionIndex];
                    temp1.order--;
                    let temp2 = this.tempSection.sections[sectionIndex - 1];
                    temp2.order++;
                    this.tempSection.sections.splice(sectionIndex - 1, 2, temp1, temp2);
                }
            },
            calculateTotal(page) {
                let total = 0;
                $.each(page.subSections, function (sectionIndex, section) {
                    $.each(section.items, function (itemIndex, item) {
                        total += item.quantity * item.price;
                    });
                });
                return total;
            },
            saveQuoteDetails() {
                let self = this;

                if(self.isUpdateQuota)
                    clearTimeout(self.isUpdateQuota);

                self.isUpdateQuota = setTimeout(function(){
                    axios.put(route('proposal-generator.quote-details.update', {proposal: self.tempSection.proposal_id, quote: self.tempSection.id}),
                    {
                        name: self.tempSection.name,
                        signature_section: self.tempSection.signature_section
                    }).then(({data})=>{
                        self.fireSuccessToast('Quote Details Successfully Updated!');
                    });
                }, 800);
            },
            openSaveAsTemplateModal() {
                $("#templateNameModal").modal("show");
            },
            saveAsTemplate() {
                this.templateForm.is_template = 1;
                this.templateForm.put('/proposal-generator/quote-details/' + this.tempSection.id + '/template')
                    .then((data) => {
                        if (data.status === 'success') {
                            $("#templateNameModal").modal("hide");
                        }
                    });
                Bus.$emit('showButton', { button: 'template', value: this.templateForm.is_template });
            },
            removeAsTemplate() {
                this.templateForm.template_name = null;
                this.templateForm.is_template = 0;
                this.templateForm.put('/proposal-generator/quote-details/' + this.tempSection.id + '/template');
                Bus.$emit('showButton', { button: 'template', value: this.templateForm.is_template });
            },
            applyTemplate() {
                if (this.selectedTemplate) {
                    this.tempSection.name = this.selectedTemplate.name;
                    this.tempSection.notes = this.selectedTemplate.notes;
                    this.tempSection.sections = this.selectedTemplate.sections;
                    this.tempSection.sections.forEach(section => {
                        section.items.forEach(item => delete item.id);
                        delete section.id;
                    });
                }
            },
            async loadPages() {
                let self = this;
                axios.get(route('proposal-generator-page.index', {section:self.section.id}))
                    .then(function ({data}) {
                        self.tempSection.sections = data;

                        data.data.forEach(function (page) {
                            page.subSections.forEach(function (subsection) {
                                self.customColumns[page.id + '-' + subsection.id + '-' + 1] = false;
                                self.customColumns[page.id + '-' + subsection.id + '-' + 2] = false;
                            })
                        })
                    })
            },
            async addPage() {
                let self = this;
                axios.post(route('proposal-generator-page.store', {section:self.section.id}))
                    .then(function ({data}) {
                        let page = {
                            id: data,
                            title: '',
                            notes: '',
                            subSections: new Array(),
                        }
                        self.tempSection.sections.data.push(page);
                        self.fireSuccessToast('Quote Details Successfully Updated!');
                    })
            },
            deletePage(pageId) {
                let self = this;
                axios.delete(route('proposal-generator-page.destroy', {pageId:pageId}))
                    .then(function () {
                        self.tempSection.sections.data = self.tempSection.sections.data.filter(function (item) {
                            return item.id != pageId;
                        })
                        self.fireSuccessToast('Quote Details Successfully Updated!');
                    })
            },
            updatePage(pageId, idx) {
                let self = this;
                clearTimeout(self.isUpdatePage[pageId])
                self.isUpdatePage[pageId] = setTimeout(function () {
                    let page = self.tempSection.sections.data[idx];
                    axios.put(route('proposal-generator-page.update', {pageId}), {title:page.title, notes:page.notes, show_total:page.show_total})
                        .then(function () {
                            self.fireSuccessToast('Quote Details Successfully Updated!');
                        })
                }, 2000)
            },
            updatePreview(){
                let iframe = document.getElementById('pdfPreview');
                iframe.src = iframe.src;
            },
            fireSuccessToast(message) {
                const Toast = Swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 2000
                });

                Toast.fire({
                    type: 'success',
                    title: message,
                });

                this.updatePreview();
            },
            signatureFooter() {
                this.tempSection.signature_section = !this.signature;
                this.signature = this.tempSection.signature_section;
            },
            updateSectionCustomColumn(sectionId, idx, sectionIndex) {
                let self = this;
                clearTimeout(self.isUpdateSubSection[sectionId])
                self.isUpdateSubSection[sectionId] = setTimeout(function () {
                    let subSection = self.tempSection.sections.data[idx].subSections[sectionIndex]
                    axios.put(route('proposal-generator-subsection.update', {sectionId}),
                        {title:subSection.title, custom_column_1:subSection.custom_column_1, custom_column_2:subSection.custom_column_2})
                        .then(function () {
                            let tempCustomColumns = {};
                            Object.keys(self.customColumns).map((currentColumn) => tempCustomColumns[currentColumn] = false);
                            self.customColumns = tempCustomColumns;

                            self.fireSuccessToast('Quote Details Successfully Updated!');
                        })
                }, 1000)

            },
            enableEditColumn(column) {
                let tempCustomColumns = {};
                Object.keys(this.customColumns).map((currentColumn) => tempCustomColumns[currentColumn] = currentColumn === column);
                this.customColumns = tempCustomColumns;

                setTimeout(function () {
                    document.getElementById(`${column}`).focus();
                }, 100)
            },
        }
    }
</script>

<style scoped>
    .non-resizeable {
        resize: none;
    }
    .reports-frame-style {
        height: 75vh;
        width: 100%;
        border: 1px solid grey;
        border-radius: 7px;
    }
</style>

